import type { ActionStatusDto } from '../types/actions-status.dto';
import type { ActionStatusModel } from '../types/actions-status.model';

export const toActionStatusModel = (dto: ActionStatusDto): ActionStatusModel => ({
	id: dto.id,
	status: dto.status,
	userIds: dto.user_ids,
	sentUserIds: dto.sent_user_ids,
	receivedUserIds: dto.received_user_ids,
	acceptedUserIds: dto.accepted_user_ids,
	declinedUserIds: dto.declined_user_ids,
	answeredUserIds: dto.answered_user_ids,
	unansweredUserIds: dto.unanswered_user_ids,
	completedUserIds: dto.completed_user_ids,
	completedTimeInMs: dto.completed_time_in_ms,
	acceptedTimeInMs: dto.accepted_time_in_ms,
	answeredTimeInMs: dto.answered_time_in_ms,
	resolvedRecipientGroups: dto.resolved_recipient_groups?.map((group) => ({
		groupNumber: group.group_number,
		recipients: group.recipients.map((recipient) => ({
			id: recipient.id,
			type: recipient.type,
			userIds: recipient.user_ids,
		})),
	})),
});
